import { supabase } from '../supabase/client';

export const DEFAULT_TEMP_PASSWORD = 'Imatics@123';

export const isFirstTimeLogin = async (userId: string) => {
  const { data, error } = await supabase
    .from('users')
    .select('first_login')
    .eq('id', userId)
    .single();

  if (error) throw error;
  return data?.first_login ?? true;
};

export const updatePassword = async (newPassword: string) => {
  try {
    // Update the auth password
    const { error: updateError } = await supabase.auth.updateUser({
      password: newPassword
    });

    if (updateError) throw updateError;

    // The trigger will automatically update first_login to false
    return true;
  } catch (error) {
    console.error('Error updating password:', error);
    throw error;
  }
};